/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import Webdevelopment from '../assets/Web deleopment Icon.svg';
import MobileAppDevelopment from '../assets/App development icon.svg';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';

function SkillItem({ icon, title, description, successRate }) {
  return (
    <Fade bottom>
      <div className="skillstyle__SkillItem-sc-1s80ywq-0 JhDR">
        <div className="skillstyle__SkillDetails-sc-1s80ywq-1 fjYYkb">
          <Zoom>
            <div className="skillstyle__SkillIcon-sc-1s80ywq-2 hIfvKd">
              <img
                src={icon}
                alt={title}
                className="Image__ImageWrapper-csrlc2-0 jZhmLy"
              />
            </div>
          </Zoom>

          <div className="skillstyle__SkillAbout-sc-1s80ywq-3 ieWna">
            <h2
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#302b4e',
              }}
              className="Heading__HeadingWrapper-sc-10v4eax-0 kngrP"
            >
              {title}
            </h2>
            <p
              style={{
                fontSize: '16px',
                fontWeight: 400,
                color: '#43414e',
              }}
              className="Text__TextWrapper-sc-49k381-0 cxbVOs"
            >
              {description}
            </p>
          </div>
        </div>

        <Slide left>
          <div className="skillstyle__SkillProgress-sc-1s80ywq-4 ktoaqZ">
            <Bounce>
              <div className="skillstyle__SuccessRate-sc-1s80ywq-5 fpOhUx">
                <i fill="currentColor" className="skill_success_icon">
                  <svg
                    fill="currentColor"
                    height="12"
                    width="12"
                    viewBox="0 0 24 24"
                  >
                    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z" />
                  </svg>
                </i>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#302b4e',
                  }}
                  className="Text__TextWrapper-sc-49k381-0 iZuvur"
                >
                  {successRate}%
                </span>
              </div>
            </Bounce>

            <Slide right>
              <div className="skillstyle__ProgressBar-sc-1s80ywq-6 itTuqr">
                <svg
                  className="rc-progress-line"
                  viewBox="0 0 100 1.8"
                  preserveAspectRatio="none"
                >
                  <path
                    className="rc-progress-line-trail"
                    d="M 0.9,0.9 L 99.1,0.9"
                    strokeLinecap="round"
                    stroke="#e3e7f2"
                    strokeWidth="1.8"
                    fillOpacity="0"
                  />
                  <path
                    className="rc-progress-line-path"
                    d="M 0.9,0.9 L 99.1,0.9"
                    strokeLinecap="round"
                    stroke="#3444f1"
                    strokeWidth="1.8"
                    fillOpacity="0"
                    style={{
                      strokeDasharray: `${successRate}px, 100px`,
                      strokeDashoffset: '-0px',
                      transition:
                        'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear',
                    }}
                  />
                </svg>
              </div>
            </Slide>
          </div>
        </Slide>
      </div>
    </Fade>
  );
}

function HelpYou() {
  const skills = [
    {
      icon: Webdevelopment,
      title: 'Web Application Development',
      description:
        'Crafting high-performance, scalable web applications with seamless UI/UX, optimized speed, and enterprise-grade security.',
      successRate: 98,
    },
    {
      icon: MobileAppDevelopment,
      title: 'Mobile Application Development',
      description:
        'Building feature-rich, cross-platform iOS & Android applications with pixel-perfect design and seamless backend integration.',
      successRate: 99,
    },
  ];

  return (
    <Fade>
      <div className="helpyou-main">
        <div className="helpyou-inner">
          <Fade top>
            <div className="helpyou-heading-text">
              <h2>Ways I can help you</h2>
              <p>
                Have a look, some could be interesting to help you achieve your
                business goals or start that project you always wanted to do...
                Yes, that one!
              </p>
            </div>
          </Fade>

          <div className="Box__BoxWrapper-sc-6cmitf-0 cFCMUs">
            {skills.map((skill, index) => (
              <Slide bottom key={index}>
                <div
                  width="1,1,0.5"
                  className="Box__BoxWrapper-sc-6cmitf-0 jaUhRq"
                >
                  <SkillItem {...skill} />
                </div>
              </Slide>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}

export default HelpYou;
